import React, { useEffect, useRef, useState } from "react";
import { toAbsoluteUrl } from "../../../../sr/helpers";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { SidebarMenuLinks } from "./SidebarMenuLinks";
import { FormattedMessage, useIntl } from "react-intl";
import { Sidebar } from "app/pages/cleaner/component/Sidebar";
import { useAuth } from "./core/Auth";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { formatISO } from "date-fns";
import { DaysConverter } from "sr/helpers/functions/DaysConverter";
import { useSocket } from "app/pages/component/SocketContext";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "sr/redux/store";
import { fetchProfileImg } from "sr/redux/reducers/profileimg";
import {
  fetchCleanerChat,
  updateUnreadChatCount,
} from "sr/redux/reducers/cleanerChat";
import {
  fetchCleanerNotification,
  removeNotificationMessage,
  updateNotificationMessage,
} from "sr/redux/reducers/cleanerNotification";
import { CHAT_TYPE } from "sr/i18n/messages/setting";
import { updateMessage } from "sr/utils/api/cleaner/updateMessage";
import { AppUseNotification } from "app/pages/component/AppUseNotification";
import { fetchcleaner } from "sr/redux/reducers/cleaner";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import { NotificationLink } from "sr/helpers/functions/NotificationLink";
import { ConditionalWrapper } from "./ConditionalWrapper";
import SmartSearchSelect from "sr/helpers/ui-components/SmartSearchSelect";
import { fetchBalance } from "sr/helpers/apiFunctions/fetchBalance";
import { fetchAppSettings } from "sr/redux/reducers/appSettings";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { STRIPE_ONBOARDING_STATUSES } from "sr/constants/common";
import { readMessage } from "sr/utils/api/cleaner/readMessage";
import { deleteMessage } from "sr/utils/api/cleaner/deleteMessage";
import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";

export default function AuthNavComponent(props) {
  const intl = useIntl();
  const [isOpened, setIsOpened] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticate, userType } = useAuth();
  const [show, setshow] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const [cleanerId, setCleanerId] = useState<string>();
  const [balance, setBalance] = useState(null);
  const [loader, setLoader] = useState(false);

  const [notificationPopup, setNotificationPopup] = useState(false);
  const [showeffect, setShowEffect] = useState(false);
  const audioFile = toAbsoluteUrl(
    "/media/notification/notification-18-270129.mp3",
  );
  const socket = useSocket();
  const unreadMessages = useSelector((state: any) => state.cleanerchat.data);
  const unreadMessageRef = useRef(unreadMessages);
  const profileImg = useSelector((state: any) => state.profileimg.data);
  const allmessage = useSelector(
    (state: any) => state.cleanerNotification.data,
  );
  const cleaner = useSelector((state: any) => state.cleaner.data);
  const [regionId, setRegionId] = useState<any>(null);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const allmessageRef = useRef(allmessage);
  const location = useLocation();
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const appSettingsReloadSetting = useSelector(
    (s: RootState) => s.appSettings.reloadSetting,
  );
  const shouldShowCleanerPaymentBanner =
    location.pathname === "/cleaner-jobs" &&
    appSettingsData &&
    appSettingsData?.isAllowCleanerPaymentSettings != undefined &&
    appSettingsData?.isAllowCleanerPaymentSettings === true &&
    userFullProfile &&
    userFullProfile?.id &&
    userFullProfile?.type &&
    userFullProfile?.type === "cleaner" &&
    (!userFullProfile?.stripe_customer_model ||
      !userFullProfile?.stripe_customer_model?.stripe_connect_ac_id ||
      !userFullProfile?.stripe_customer_model?.stripe_onboarding_status ||
      (userFullProfile?.stripe_customer_model?.stripe_connect_ac_id &&
        userFullProfile?.stripe_customer_model?.stripe_onboarding_status &&
        userFullProfile?.stripe_customer_model?.stripe_onboarding_status !==
          STRIPE_ONBOARDING_STATUSES.SUCCESS));
  const activeCleanerJobId = location.pathname.startsWith("/cleaner/message")
    ? new URLSearchParams(location.search).get("jobId")
    : null;
  const getUnreadChatJobId = (item) => item?.job_id?._id || item?.job_id;
  const visibleUnreadMessages = activeCleanerJobId
    ? unreadMessages?.filter(
        (item) => getUnreadChatJobId(item) !== activeCleanerJobId,
      )
    : unreadMessages;
  const ToggleHandle = () => {
    setIsOpened(!isOpened);
  };
  const navigate = useNavigate();
  const SidebarHandle = () => {
    setSidebarOpen(false);
  };
  useEffect(() => {
    if (isAuthenticate === false) {
      setSidebarOpen(false);
    }
  }, [isAuthenticate]);
  const HandleSubmit = (e) => {
    e.preventDefault();
    if (e.target[0].value) {
      navigate(`/search/${e.target[0].value}`);
    }
  };
  useEffect(() => {
    const getdetails = getUserDetails();
    setCleanerId(getdetails?.user_id);
    dispatch(fetchAppSettings());
  }, []);
  useEffect(() => {
    if (location.pathname !== "/cleaner-jobs") return;

    (async () => {
      const userFullProfileRes = await getUserFullProfile();
      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, [appSettingsReloadSetting, location.pathname]);
  useEffect(() => {
    if (cleanerId && userType === "cleaner") {
      if (!profileImg) {
        dispatch(fetchProfileImg({ cleaner_id: cleanerId }));
      }
      if (!unreadMessages) {
        dispatch(fetchCleanerChat({ cleanerId: cleanerId }));
      }
      if (!allmessage?.length) {
        dispatch(fetchCleanerNotification({ cleanerId: cleanerId }));
      }
      if (!cleaner) {
        dispatch(fetchcleaner({ id: cleanerId }));
      }
    }
  }, [cleanerId]);
  useEffect(() => {
    if (!cleanerId || userType !== "cleaner" || !socket) return;

    socket.emit("register", cleanerId);
    socket.emit("getonlineusers", cleanerId);

    const handleSendMessage = ({ from, messagewithFullData: message }) => {
      if (message) {
        if (message?.sender_id_type === "cleaner") {
            return;
        }

        const msgJobId = typeof message.job_id === 'string' ? message.job_id : (message.job_id?._id || message.job_id?.id);
        const msgSenderId = typeof message.sender_id === 'string' ? message.sender_id : (message.sender_id?._id || message.sender_id?.id);

        const urlParams = new URLSearchParams(window.location.search);
        const currentJobId = urlParams.get("jobId");
        
        const isCurrentlyViewing = window.location.pathname.includes('/cleaner/message') && currentJobId === msgJobId;

        const audio = new Audio(audioFile);
        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));
          
        const currentDateTime = formatISO(new Date());
        const tempId = message?._id || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newmessage = { createdAt: currentDateTime, _id: tempId, ...message };

        if (message?.sender_id_type === "individual") {
          if (Object.values(CHAT_TYPE)?.includes(message?.type)) {
            dispatch(
              updateNotificationMessage([
                ...(allmessageRef.current || []),
                newmessage,
              ]),
            );
          }
        }
        
        if (message?.sender_id_type === "company") {
          dispatch(
            updateNotificationMessage([
              ...(allmessageRef.current || []),
              newmessage,
            ]),
          );
          
          if (!isCurrentlyViewing) {
              dispatch(
                updateUnreadChatCount({
                  ...message,
                  job_id: { _id: msgJobId },
                }),
              );
          }
        }

        if (isCurrentlyViewing) {
            setTimeout(() => {
                const updated = allmessageRef.current?.map((item: any) => 
                    item._id === tempId ? { ...item, readed: true } : item
                );
                if (updated) {
                    dispatch(updateNotificationMessage(updated));
                }
            }, 2500);
        }
      }
    };

    const handleNotificationMessage = (message) => {
      if (message) {
        const audio = new Audio(audioFile);
        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));
        const currentDateTime = formatISO(new Date());
        const newmessage = { createdAt: currentDateTime, ...message };
        dispatch(
          updateNotificationMessage([
            ...(allmessageRef.current || []),
            newmessage,
          ]),
        );
      }
    };

    socket.on("sendmessage", handleSendMessage);
    socket.on("notification", handleNotificationMessage);

    return () => {
      socket.off("sendmessage", handleSendMessage);
      socket.off("notification", handleNotificationMessage);
    };
  }, [cleanerId, userType, socket]);
  const handleNotification = () => {
    if (allmessage?.length < 1) return;
    if (!notificationPopup) {
      setNotificationPopup(true);
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setTimeout(() => {
        setShowEffect(false);
      }, 200);
      setTimeout(() => {
        setNotificationPopup(false);
      }, 500);
    }
  };
  const sortedMessage = [...(allmessage || [])].sort((a, b) => {
    const adate = new Date(a?.createdAt);
    const bdate = new Date(b?.createdAt);
    return bdate.getTime() - adate.getTime(); // descending (newest first)
  });
  useEffect(() => {
    unreadMessageRef.current = unreadMessages;
  }, [unreadMessages]);
  useEffect(() => {
    allmessageRef.current = allmessage;
  }, [allmessage]);

  const handleDelete = async (id?: string) => {
    try {
      if (!cleanerId || !id) return;

      const payload = {
        recipient_id: cleanerId,
        id,
      };

      const res = await deleteMessage(payload);

      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id }));
      }
    } catch (e) {
      console.error("Delete failed:", e);
    }
  };

  const handleRemove = async (id?: any) => {
    try {
      const payload = {
        id: id,
        readed: true,
      };
      const updateMessagePayload = allmessage?.map((item: any) => ({
        ...item,
        readed: true,
      }));

      const res = await updateMessage(id ? payload : updateMessagePayload);
      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id: id }));
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (cleaner?.regionId?.id) {
      setRegionId(cleaner?.regionId);
      setRegionIdMe(cleaner?.regionId?.id);
    }
  }, [cleaner?.regionId?.id]);

  const handleRegionChange = (selectedItem: any) => {
    setRegionIdMe(selectedItem);
    setRegionId(selectedItem);
    if (props?.setRegion) props?.setRegion(selectedItem);
  };

  useEffect(() => {
    if (cleanerId) {
      fetchBalance({
        userId: cleanerId,
        setData: setBalance,
        setLoader: setLoader,
      });
    }
  }, [isOpened, cleanerId]);

  const handleRead = async (id?: string) => {
    try {
      if (!cleanerId) return;

      const payload = {
        recipient_id: cleanerId,
        ...(id && { id }),
      };
      console.log("Payload of read: ", payload);
      const res = await readMessage(payload);

      if (res?.success === true) {
        const updated = allmessage?.map((item: any) =>
          id
            ? item._id === id
              ? { ...item, readed: true }
              : item
            : { ...item, readed: true },
        );

        dispatch(updateNotificationMessage(updated));
        dispatch(fetchCleanerChat({ cleanerId: cleanerId }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="flex flex-col">
      <>
        <AppUseNotification></AppUseNotification>
        <nav
          className={` ${
            isOpened ? "z-[47]	sticky top-0 inset-x-0 " : "static"
          } sticky lg:space-x-3 xl:space-x-3 top-0 z-[47] bg-navy text-white flex items-center p-4`}
        >
          <Link to="/" className="z-[47]">
            <img
              width={150}
              src={toAbsoluteUrl("/media/logos/logo1.png")}
              alt=""
              className=""
            />
          </Link>

          {props.isLoggedin && (
            <>
              <div
                className={`z-20 opacity-100 lg:flex lg:justify-end lg:grow fixed inset-0 bg-white lg:bg-transparent shadow-xl transition duration-300 lg:w-20 w-[80%] lg:static lg:shadow-none lg:translate-x-0 ${
                  isOpened
                    ? "translate-x-0 delay-100	dark:bg-gray-800 border-gray-100"
                    : "-translate-x-[100%]"
                }`}
              >
                {isAuthenticate && userType === "cleaner" && (
                  <>
                    <hr className="border-gray-200 my-2 mt-24 lg:hidden" />
                    <div className="flex lg:hidden items-center space-x-4 px-4 py-3">
                      <div className="radius-50 ">
                        <img
                          alt="Profile"
                          className="rounded-full w-14 h-14"
                          src={
                            profileImg
                              ? profileImg
                              : toAbsoluteUrl(
                                  "/media/icons/displayProfilePlaceholder.png",
                                )
                          }
                        />
                      </div>
                      <div className="text-black">
                        <div className="font-bold text-base">
                          {cleaner?.first_name} {cleaner?.last_name}
                        </div>
                        <Link
                          to={"/cleaner-profile-page"}
                          className="font-bold text-xs text-[#0078ae]  mt-3 cursor-pointer"
                        >
                          View & Update Profile
                        </Link>
                      </div>
                    </div>
                    <hr className="border-gray-200 my-2 lg:hidden" />

                    <div className="space-x-4 px-4 text-center lg:hidden xl:hidden">
                      <p className=" text-base text-black">Total Balance</p>
                      <p className="text-black text-base">
                        <span>$</span>
                        {Number(balance?.balance)?.toFixed(2) || 0.0}
                      </p>

                      <Link
                        className="font-700 text-xs text-[#0078ae]  mt-3 cursor-pointer font-bold"
                        to={"/cleaner/wallet"}
                      >
                        View Details
                      </Link>
                    </div>
                    <hr className="border-gray-200 my-2 lg:hidden xl:hidden" />
                  </>
                )}
                <SidebarMenuLinks />
                <ul className="lg:flex-1 lg:flex lg:justify-center lg:items-center lg:text-white text-black lg:m-0 hidden">
                  <li className="group  relative dropdown cursor-pointer font-mono font-bold lg:font-normal py-2 px-4 lg:p-0">
                    {" "}
                    <Link
                      to="/cleaner-jobs"
                      replace
                      className="mr-7 hover:text-pink"
                    >
                      <FormattedMessage
                        id="NAVBAR.COMPANY.JOBS.TITLE"
                        defaultMessage="Jobs"
                      />
                    </Link>
                    <div className="group-hover:block dropdown-menu absolute hidden h-auto z-10">
                      {isAuthenticate && userType === "cleaner" && (
                        <ul className="top-0 w-64 bg-white shadow px-6 py-8 rounded-lg">
                          <li className="py-1">
                            <Link
                              className="block text-base cursor-pointer text-black"
                              to="/applied-jobs"
                            >
                              <FormattedMessage
                                id="NAVBAR.APPLIED.JOBS.TITLE"
                                defaultMessage="Applied Jobs"
                              />
                            </Link>
                          </li>
                          <li className="py-1">
                            <Link
                              className="block text-base cursor-pointer text-black"
                              to="/saved-jobs"
                            >
                              <FormattedMessage
                                id="NAVBAR.SAVED.JOBS.TITLE"
                                defaultMessage="Saved Jobs"
                              />
                            </Link>
                          </li>
                        </ul>
                      )}
                    </div>
                  </li>

                  <li className="group  relative dropdown cursor-pointer font-mono font-bold lg:font-normal py-2 px-4 lg:p-0">
                    <Link
                      to="/cleaner/work-order"
                      replace
                      className="mr-7 hover:text-pink"
                    >
                      <FormattedMessage
                        id="NAVBAR.WORK.ORDER.TITLE"
                        defaultMessage="Work Order"
                      />
                    </Link>
                    {isAuthenticate && userType === "cleaner" && (
                      <div className="group-hover:block dropdown-menu absolute hidden h-auto z-10">
                        <ul className="top-0 w-64 bg-white shadow px-6 py-8 rounded-lg">
                          <Link
                            className="block text-base cursor-pointer text-black"
                            to="/cleaner/work-order"
                          >
                            Find Work
                          </Link>
                          <li className="py-1">
                            <Link
                              className="block text-base cursor-pointer text-black"
                              to="/cleaner/applied-work-order"
                            >
                              {" "}
                              <FormattedMessage
                                id="NAVBAR.APPLIED.WORK.ORDER.TITLE"
                                defaultMessage="Requested Work Order"
                              />
                            </Link>
                          </li>
                          <li className="py-1">
                            <Link
                              to="/my-jobs"
                              className="block text-base cursor-pointer text-black"
                            >
                              <FormattedMessage
                                id="NAVBAR.MY.JOBS.TITLE"
                                defaultMessage="My Jobs"
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    )}
                  </li>

                  <li className="group  relative dropdown cursor-pointer font-mono font-bold lg:font-normal py-2 px-4 lg:p-0">
                    {" "}
                    <Link
                      to="/companies"
                      replace
                      className="mr-7 hover:text-pink"
                    >
                      <FormattedMessage
                        id="NAVBAR.COMPANIES.TITLE"
                        defaultMessage="Companies"
                      />{" "}
                    </Link>
                  </li>
                  {isAuthenticate && userType === "cleaner" && (
                    <>
                      <li className="group  relative dropdown cursor-pointer font-mono font-bold lg:font-normal py-2 px-4 lg:p-0">
                        <div className="flex space-x-1 items-center mr-7">
                          <Link
                            to="/cleaner/message"
                            replace
                            className=" hover:text-pink"
                          >
                            Messages{" "}
                          </Link>
                          {visibleUnreadMessages &&
                            visibleUnreadMessages?.length > 0 && (
                              <div className="rounded-full bg-[#ff39b3] font-bold w-4 h-4 flex justify-center items-center">
                                <span className="text-[0.8rem] ">
                                  {visibleUnreadMessages?.length}
                                </span>
                              </div>
                            )}
                        </div>
                      </li>
                      <li className="group  relative dropdown cursor-pointer font-mono font-bold lg:font-normal py-2 px-4 lg:p-0">
                        {" "}
                        <Link
                          to="/cleaner/reward"
                          replace
                          className="mr-7 hover:text-pink"
                        >
                          Reward
                        </Link>
                      </li>
                    </>
                  )}
                </ul>{" "}
              </div>
              <div className="lg:block hidden">
                <form
                  onSubmit={(e: any) => HandleSubmit(e)}
                  className="relative flex"
                >
                  <input
                    onClick={() => setshow(true)}
                    type="search"
                    className="w-60 h-10 rounded-3xl p-5 text-gray-900"
                    placeholder={intl.formatMessage({
                      id: "INPUT.SEARCH.JOBS.PLACEHOLDER",
                      defaultMessage: "Search jobs",
                    })}
                  ></input>
                  <button className="h-8  w-8 rounded-full bg-[#ff39b3] font-bold flex justify-center items-center absolute top-1 right-2">
                    <FontAwesomeIcon
                      icon={faMagnifyingGlass}
                      className="text-white text-lg font-bold "
                    />
                  </button>
                </form>
              </div>

              <div className="profile-container flex-1">
                <div className="ml-4 flex lg:gap-4 xl:gap-4 gap-2 items-center justify-end">
                  {isAuthenticate && userType === "cleaner" ? (
                    <>
                      {cleaner?.regionId?.city && (
                        <SmartSearchSelect
                          className="mt-0 w-[70%]"
                          value={regionId?.id ? regionId?.id : regionId}
                          onChange={handleRegionChange}
                          label=""
                          options={regionId ? [regionId] : []} // Pass empty array if regions is null
                          placeholder="Select Region"
                        />
                      )}
                      <a
                        href="https://support.janijobs.com/hc/en-us"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center w-10 h-10 lg:w-12 lg:h-12 text-white hover:text-pink"
                      >
                        <FontAwesomeIcon
                          icon={faCircleQuestion}
                          className="text-xl lg:text-2xl"
                        />
                      </a>
                      <div
                        onClick={() => handleNotification()}
                        className="relative cursor-pointer lg:w-10 xl:w-10 w-8 flex justify-end"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                          />
                        </svg>
                        {allmessage?.filter((item) => !item.readed).length >
                          0 && (
                          <div className="rounded-full bg-[#ff39b3] font-bold w-4 h-4 flex justify-center items-center absolute -top-2 right-0">
                            <span className="text-[0.8rem] ">
                              {allmessage.filter((item) => !item.readed).length}
                            </span>
                          </div>
                        )}
                        <div
                          className={`dropdown-menu transitioncss  fixed ${
                            notificationPopup ? "block" : "hidden"
                          } ${
                            showeffect ? "modeleffect" : "popup"
                          } w-[450px] max-h-[500px] top-14 z-50 overflow-y-scroll rounded-lg border border-2xl`}
                        >
                          <div className="bg-white shadow text-black">
                            <p
                              onClick={() => handleRead()}
                              className="text-right text-sm font-bold  text-[#0078ae] pr-2 cursor-pointer"
                            >
                              Mark all as read
                            </p>
                            {sortedMessage
                              .sort((a, b) => {
                                const adate = new Date(a?.createdAt);
                                const bdate = new Date(b?.createdAt);

                                const differenceInMilliseconds =
                                  bdate.getTime() - adate.getTime();
                                return differenceInMilliseconds;
                              })
                              ?.map((item, index) => (
                                <ConditionalWrapper
                                  condition={
                                    item?.sender_id_type === "individual"
                                      ? `/cleaner/individual/chat/${item?.individual_job_id}`
                                      : NotificationLink(item)
                                  }
                                  key={index}
                                >
                                  <div
                                    onClick={() => {
                                      if (!item?.readed && item?._id) {
                                        handleRead(item?._id);
                                      }
                                    }}
                                    className={`relative flex w-full items-start gap-3 p-4 cursor-pointer transition-all duration-200 min-h-[90px]}`}
                                  >
                                    {/* Profile Image */}
                                    <div className="w-14 h-14">
                                      <img
                                        className="h-14 w-14 rounded-full"
                                        src={toAbsoluteUrl(
                                          "/media/icons/displayProfilePlaceholder.png",
                                        )}
                                      />
                                    </div>

                                    {/* Message Content */}
                                    <div className="flex-1 pr-6">
                                      <div className="flex justify-between">
                                        <span className="text-xs text-gray-400">
                                          {DaysConverter(item?.createdAt)} Ago
                                        </span>
                                      </div>
                                      {item?.sender_id_type === "company" && (
                                        <p
                                          className={`text-sm mt-1 ${
                                            !item?.readed
                                              ? "font-bold text-black"
                                              : "text-gray-500"
                                          }`}
                                        >
                                          {item?.sender_id?.company_name ||
                                            item?.sender_id?.name ||
                                            "Company"}{" "}
                                          messaged you
                                        </p>
                                      )}

                                      <p
                                        className={`text-sm mt-1 line-clamp-4 ${
                                          !item?.readed
                                            ? "font-bold text-black"
                                            : "text-gray-500"
                                        }`}
                                      >
                                        {item?.message}
                                      </p>
                                      {item?.metaData?.urgency === "high" && (
                                          <span className="inline-flex items-center rounded-full bg-[#ff39b3] px-2.5 py-0.5 text-xs font-medium text-white">
                                            Urgent
                                          </span>
                                        )}
                                    </div>

                                    {/* Cancel Icon */}
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        handleDelete(item?._id);
                                      }}
                                      className="absolute top-2 right-2 cursor-pointer p-1 rounded-full hover:bg-gray-200 transition"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={2}
                                        stroke="currentColor"
                                        className="w-4 h-4 text-gray-500 hover:text-black"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M6 18 18 6M6 6l12 12"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                </ConditionalWrapper>
                              ))}
                          </div>
                        </div>
                      </div>
                      <div
                        onClick={() => setSidebarOpen(true)}
                        className="p-[2px] bg-white rounded-full float-right cursor-pointer lg:block xl:block hidden"
                      >
                        <img
                          className="lg:w-14 lg:h-14 w-10 h-10 rounded-full"
                          src={
                            profileImg
                              ? profileImg
                              : toAbsoluteUrl(
                                  "/media/icons/displayProfilePlaceholder.png",
                                )
                          }
                        ></img>
                      </div>
                    </>
                  ) : (
                    <>
                      <Link
                        to={"/auth"}
                        className="bg-transparent hover:bg-blue-500 text-white font-semibold hover:text-white py-2 px-4 border hover:border-transparent rounded"
                      >
                        Login
                      </Link>
                      <Link
                        to={"/create-cleaner"}
                        className="bg-[#ff39b3] hover:bg-blue-500 text-white font-semibold hover:text-white py-2 px-4 border rounded"
                      >
                        Register
                      </Link>
                    </>
                  )}

                  <div onClick={ToggleHandle} className="lg:hidden z-20">
                    <div
                      className={`w-6 h-0.5 rounded bg-white transation duration-300 ${
                        isOpened ? "translate-y-2 rotate-45" : ""
                      } `}
                    ></div>
                    <div
                      className={`w-6 h-0.5 mt-1.5 rounded bg-white transation duration-300 ${
                        isOpened ? "opacity-0" : ""
                      } `}
                    ></div>
                    <div
                      className={`w-6 h-0.5 mt-1.5 rounded bg-white transation duration-300 ${
                        isOpened ? "-translate-y-2 -rotate-45" : ""
                      } `}
                    ></div>
                  </div>
                </div>{" "}
              </div>
            </>
          )}

          <span
            onClick={ToggleHandle}
            className={`fixed w-full h-full top-0 left-0 delay-100 visible opacity-100 bg-[#00000099] ${
              isOpened ? "block" : "hidden"
            }`}
          ></span>
          {notificationPopup && (
            <span
              onClick={() => {
                handleNotification();
              }}
              className="fixed  w-full h-full z-[40] inset-0 delay-100 visible opacity-100 bg-[#00000099]"
              style={{ width: "100vw" }}
            ></span>
          )}
        </nav>
        <Sidebar
          sidebarOpen={sidebarOpen}
          SidebarHandle={SidebarHandle}
        ></Sidebar>
      </>
      {shouldShowCleanerPaymentBanner && (
        <div className="flex justify-center items-center gap-x-6 bg-red-400 px-6 py-2.5 sm:px-3.5">
          <p className="text-sm/6 text-white">
            {intl.formatMessage({
              id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
              defaultMessage: "Please setups your payment method first",
            })}
            <Link
              to="/cleaner-profile-page?tab=payment-settings"
              className="cursor-pointer"
            >
              &nbsp;
              <span aria-hidden="true">&rarr;</span>
            </Link>
          </p>
        </div>
      )}
    </div>
  );
}
